/* MM / Slider produits — assets/mm-product-slider.js
   La piste est un Splide monté par SplideManager (mm_components.js) : drag,
   molette et barre de progression (pouce data-progress-style="thumb") sont
   natifs. Reste ici le fondu de sortie à gauche et la lecture de la vidéo
   d'accroche. Idempotent (garde data-mm-pslider-ready) : les previews
   ré-exécutent les scripts. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.mmPsliderReady === 'true') return;
    root.dataset.mmPsliderReady = 'true';

    var slider = root.querySelector('.mm-pslider__slider');
    var track = root.querySelector('.mm-pslider__track');

    /* La piste commence pile au bord de l'accroche : sans rien, une carte qui
       en sort serait tranchée net contre le bloc. On pose donc un fondu — mais
       SEULEMENT une fois la piste défilée. Au repos, un masque rendrait le
       bord gauche de la première carte translucide, ce qui se lit comme un
       défaut de rendu et non comme une intention.
       Move.getPosition() = translation réelle de la liste (négative une fois
       défilée), lue pendant le drag comme pendant la transition. L'instance
       est montée par SplideManager à l'approche (IntersectionObserver) : on
       attend son signal si elle n'existe pas encore. */
    var splide = null;
    function syncFondu() {
      track.classList.toggle('is-scrolled', splide.Components.Move.getPosition() < -2);
    }
    function bindSplide() {
      if (splide || !slider || !track || !slider._splide) return;
      splide = slider._splide;
      splide.on('move moved dragging dragged', syncFondu);
      syncFondu();
    }
    bindSplide();
    document.addEventListener('global:splide-initialized', bindSplide);

    var video = root.querySelector('[data-pslider-video]');
    if (video && window.IntersectionObserver) {
      video.muted = true;
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '200px 0px' });
      if (document.readyState === 'complete') videoObserver.observe(video);
      else window.addEventListener('load', function () { videoObserver.observe(video); }, { once: true });
    }
  }

  function setup(scope) {
    (scope || document).querySelectorAll('.mm-pslider').forEach(init);
  }

  window.MmProductSlider = { setup: setup };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); });
  } else {
    setup();
  }
})();
